import BlogPage from './BlogPage';

export default BlogPage;



// WEBPACK FOOTER //
// ./src/components/BlogPage/index.js